import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import styled from 'styled-components'

const TabWrap = styled(Flex) <{
  isSelected: boolean,
  isFirst: boolean,
  isLast: boolean,
  isMinimized?: boolean
}>`
  background:${props => props.isSelected ? 'white' : 'rgba(255, 255, 255, 0.3)'};
  transition: all 0.3s ease;
  flex-direction: column;
  height: ${props => !!props.isMinimized ? '62px' : '82px'};
  width: ${props => !!props.isMinimized ? '106px' : '136px'};
  justify-content: center;
  align-items: center;
  border-top-left-radius: ${props => props.isFirst ? '12px' : '0'};
  border-bottom-left-radius: ${props => props.isLast  && !props.isMinimized ? '12px' : '0'};
  border-top-right-radius: ${props => props.isLast  && !!props.isMinimized ? '12px' : '0'};
  font-size: ${props => !!props.isMinimized ? '12px' : ''};
  cursor:pointer;
  border-bottom: ${props => props.isLast ? '' : '1px solid rgba(255, 255, 255, 0.7)'};
  &:hover {
  background:${props => props.isSelected ? 'white' : 'rgba(255, 255, 255, 0.5)'};
  }
`
const ContentWrapper = styled(Flex)`
overflow-y: auto;
width: 100%;
flex:1;
 flex-direction:column;
&::-webkit-scrollbar-track {
  background: transparent;
}
&::-webkit-scrollbar-thumb {
  background: #6c89b7;
  border-radius: 5px;
}
    &::-webkit-scrollbar {
        width: 7px;
        border: 1px solid transparent;
    }
`

export interface ITab {
  title: string,
  name: string,
  icon: React.ReactNode,
  content: React.ReactNode
  contentWrapperStyle?: React.CSSProperties | undefined
}
interface ITabulatorProps {
  tabs: Array<ITab>
  onTabChanged?: (e: string) => void
  selectedTab?: string
  isMinimized?: boolean
}

const Tab: React.FC<{
  title: string,
  name: string,
  icon: React.ReactNode,
  isSelected: boolean,
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void,
  isFirst: boolean,
  isLast: boolean,
  isMinimized?: boolean
}> = ({
  title,
  name,
  icon, isSelected, onClick,
  isFirst,
  isLast, isMinimized }) => {
    return (
      <TabWrap
        isMinimized={isMinimized}
        isFirst={isFirst}
        isLast={isLast}
        isSelected={isSelected} onClick={onClick}>
        {icon}
        <Text mt={1}>{title}</Text>
      </TabWrap>
    )
  }

export const Tabulator: React.FC<ITabulatorProps> = ({ tabs, onTabChanged, selectedTab, isMinimized }) => {
  const [currentTab, setCurrentTab] = useState(selectedTab || tabs[0].name)

  useEffect(() => {
    setCurrentTab(selectedTab || tabs[0].name)
    if(onTabChanged) {
      onTabChanged(selectedTab || tabs[0].name)
    }
  }, [selectedTab])

  useEffect(()=>{
    if(onTabChanged) {
      onTabChanged(currentTab || tabs[0].name)
    }
  }, [])
  useEffect(()=>{
    if(onTabChanged) {
      onTabChanged(currentTab || tabs[0].name)
    }
  }, [currentTab])

  return (
    <Flex width={'100%'} height={'100%'} flexDirection={isMinimized ? 'column' : 'row'}>
      <Flex flexDirection={isMinimized ? 'row' : 'column'} >
        <Flex flexDirection={isMinimized ? 'row' : 'column'} pl={isMinimized ? '20px' : 0} pr={isMinimized ? '20px' : 0} pt={isMinimized ? 0 : '20px'} style={{ position: 'sticky', top: 0, left: 0 }}>
          {tabs.map((x, i) => {
            return (
              <Tab isMinimized={isMinimized} isFirst={i === 0} isLast={i === tabs.length - 1} {...x} key={x.name} isSelected={x.name === currentTab} onClick={(e) => setCurrentTab(x.name)} />
            )
          })}
        </Flex>
      </Flex>
      <Flex flex={1} backgroundColor={'white'} height={'calc(100vh - 246px)'} maxHeight={!isMinimized?'calc(100vh - 246px)':'calc(100vh - 276px)'} style={{
        overflow: 'hidden',
        borderRadius: '20px', padding: '8px'
      }}>
        <ContentWrapper style={tabs.find(x => x.name === currentTab)?.contentWrapperStyle}>
          {tabs.find(x => x.name === currentTab)?.content}
        </ContentWrapper>
      </Flex>
    </Flex>);
}
